/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.0.0 (NJsonSchema v10.1.24.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const ImportLogApiBaseUrl = new InjectionToken<string>('ImportLogApiBaseUrl');

@Injectable({
    providedIn: 'root'
})
export class ImportLogImportLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ImportLogApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5310";
    }

    getLimited(uploadedBy?: string | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, uploadPage?: string | null | undefined, limit?: number | undefined, offset?: number | undefined, sort?: string | null | undefined, ascending?: boolean | undefined): Observable<LimitedResultOfImportLogViewModel> {
        let url_ = this.baseUrl + "/importlog/v1/importlog/getlimited?";
        if (uploadedBy !== undefined && uploadedBy !== null)
            url_ += "UploadedBy=" + encodeURIComponent("" + uploadedBy) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (uploadPage !== undefined && uploadPage !== null)
            url_ += "UploadPage=" + encodeURIComponent("" + uploadPage) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (ascending === null)
            throw new Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLimited(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLimited(<any>response_);
                } catch (e) {
                    return <Observable<LimitedResultOfImportLogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LimitedResultOfImportLogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetLimited(response: HttpResponseBase): Observable<LimitedResultOfImportLogViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfImportLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfImportLogViewModel>(<any>null);
    }

    export(uploadedBy?: string | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, uploadPage?: string | null | undefined, limit?: number | undefined, offset?: number | undefined, sort?: string | null | undefined, ascending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/importlog/v1/importlog/export?";
        if (uploadedBy !== undefined && uploadedBy !== null)
            url_ += "UploadedBy=" + encodeURIComponent("" + uploadedBy) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (uploadPage !== undefined && uploadPage !== null)
            url_ += "UploadPage=" + encodeURIComponent("" + uploadPage) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (ascending === null)
            throw new Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getLatestForPage(page?: string | null | undefined): Observable<ImportLogViewModel> {
        let url_ = this.baseUrl + "/importlog/v1/importlog/latest?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestForPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestForPage(<any>response_);
                } catch (e) {
                    return <Observable<ImportLogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportLogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestForPage(response: HttpResponseBase): Observable<ImportLogViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportLogViewModel>(<any>null);
    }

    addImportLog(page?: string | null | undefined, uploadedDate?: moment.Moment | undefined, uploadedBy?: string | null | undefined, fileUploadedContent?: FileParameter | null | undefined, security_RequiredPermission?: string | null | undefined, security_ScopeToAccount?: number | null | undefined): Observable<AddImportLogResponse> {
        let url_ = this.baseUrl + "/importlog/v1/importlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (page !== null && page !== undefined)
            content_.append("Page", page.toString());
        if (uploadedDate === null || uploadedDate === undefined)
            throw new Error("The parameter 'uploadedDate' cannot be null.");
        else
            content_.append("UploadedDate", uploadedDate.toJSON());
        if (uploadedBy !== null && uploadedBy !== undefined)
            content_.append("UploadedBy", uploadedBy.toString());
        if (fileUploadedContent !== null && fileUploadedContent !== undefined)
            content_.append("FileUploadedContent", fileUploadedContent.data, fileUploadedContent.fileName ? fileUploadedContent.fileName : "FileUploadedContent");
        if (security_RequiredPermission !== null && security_RequiredPermission !== undefined)
            content_.append("Security.RequiredPermission", security_RequiredPermission.toString());
        if (security_ScopeToAccount !== null && security_ScopeToAccount !== undefined)
            content_.append("Security.ScopeToAccount", security_ScopeToAccount.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddImportLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddImportLog(<any>response_);
                } catch (e) {
                    return <Observable<AddImportLogResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddImportLogResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddImportLog(response: HttpResponseBase): Observable<AddImportLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddImportLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddImportLogResponse>(<any>null);
    }

    getPages(): Observable<string[]> {
        let url_ = this.baseUrl + "/importlog/v1/importlog/getpages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPages(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPages(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    downloadFile(id: string | null, fileName: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/importlog/v1/importlog/{id}/download/{fileName}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiExceptionOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiExceptionOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiExceptionOfString.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; } | null;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data; 
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; } | null;
}

export class ApiError extends ProblemDetails implements IApiError {
    error?: string | null;
    errorKey?: any | null;

    constructor(data?: IApiError) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : <any>null;
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ApiError {
        const json = this.toJSON();
        let result = new ApiError();
        result.init(json);
        return result;
    }
}

export interface IApiError extends IProblemDetails {
    error?: string | null;
    errorKey?: any | null;
}

export class LimitedResultOfImportLogViewModel implements ILimitedResultOfImportLogViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ImportLogViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;

    constructor(data?: ILimitedResultOfImportLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ImportLogViewModel.fromJS(item));
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
        }
    }

    static fromJS(data: any): LimitedResultOfImportLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfImportLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        return data; 
    }

    clone(): LimitedResultOfImportLogViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfImportLogViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfImportLogViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ImportLogViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
}

export class ImportLogViewModel implements IImportLogViewModel {
    page?: string | null;
    uploadedDate?: moment.Moment | null;
    uploadedBy?: string | null;
    fileUploadedUrl?: string | null;
    fileUploadedName?: string | null;

    constructor(data?: IImportLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.uploadedDate = _data["uploadedDate"] ? moment(_data["uploadedDate"].toString()) : <any>null;
            this.uploadedBy = _data["uploadedBy"] !== undefined ? _data["uploadedBy"] : <any>null;
            this.fileUploadedUrl = _data["fileUploadedUrl"] !== undefined ? _data["fileUploadedUrl"] : <any>null;
            this.fileUploadedName = _data["fileUploadedName"] !== undefined ? _data["fileUploadedName"] : <any>null;
        }
    }

    static fromJS(data: any): ImportLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>null;
        data["uploadedBy"] = this.uploadedBy !== undefined ? this.uploadedBy : <any>null;
        data["fileUploadedUrl"] = this.fileUploadedUrl !== undefined ? this.fileUploadedUrl : <any>null;
        data["fileUploadedName"] = this.fileUploadedName !== undefined ? this.fileUploadedName : <any>null;
        return data; 
    }

    clone(): ImportLogViewModel {
        const json = this.toJSON();
        let result = new ImportLogViewModel();
        result.init(json);
        return result;
    }
}

export interface IImportLogViewModel {
    page?: string | null;
    uploadedDate?: moment.Moment | null;
    uploadedBy?: string | null;
    fileUploadedUrl?: string | null;
    fileUploadedName?: string | null;
}

export class AddImportLogResponse implements IAddImportLogResponse {
    id?: string | null;
    page?: string | null;
    uploadedDate?: moment.Moment;
    uploadedBy?: string | null;
    fileUploadedName?: string | null;
    fileUploadedUrl?: string | null;

    constructor(data?: IAddImportLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.uploadedDate = _data["uploadedDate"] ? moment(_data["uploadedDate"].toString()) : <any>null;
            this.uploadedBy = _data["uploadedBy"] !== undefined ? _data["uploadedBy"] : <any>null;
            this.fileUploadedName = _data["fileUploadedName"] !== undefined ? _data["fileUploadedName"] : <any>null;
            this.fileUploadedUrl = _data["fileUploadedUrl"] !== undefined ? _data["fileUploadedUrl"] : <any>null;
        }
    }

    static fromJS(data: any): AddImportLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddImportLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>null;
        data["uploadedBy"] = this.uploadedBy !== undefined ? this.uploadedBy : <any>null;
        data["fileUploadedName"] = this.fileUploadedName !== undefined ? this.fileUploadedName : <any>null;
        data["fileUploadedUrl"] = this.fileUploadedUrl !== undefined ? this.fileUploadedUrl : <any>null;
        return data; 
    }

    clone(): AddImportLogResponse {
        const json = this.toJSON();
        let result = new AddImportLogResponse();
        result.init(json);
        return result;
    }
}

export interface IAddImportLogResponse {
    id?: string | null;
    page?: string | null;
    uploadedDate?: moment.Moment;
    uploadedBy?: string | null;
    fileUploadedName?: string | null;
    fileUploadedUrl?: string | null;
}

export class Exception implements IException {
    stackTrace?: string | null;
    message?: string;
    innerException?: Exception | null;
    source?: string | null;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stackTrace = _data["StackTrace"] !== undefined ? _data["StackTrace"] : <any>null;
            this.message = _data["Message"] !== undefined ? _data["Message"] : <any>null;
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : <any>null;
            this.source = _data["Source"] !== undefined ? _data["Source"] : <any>null;
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>null;
        data["Source"] = this.source !== undefined ? this.source : <any>null;
        return data; 
    }

    clone(): Exception {
        const json = this.toJSON();
        let result = new Exception();
        result.init(json);
        return result;
    }
}

export interface IException {
    stackTrace?: string | null;
    message?: string;
    innerException?: Exception | null;
    source?: string | null;
}

export abstract class ApiException extends Exception implements IApiException {
    statusCode?: HttpStatusCode;

    constructor(data?: IApiException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : <any>null;
        }
    }

    static fromJS(data: any): ApiException {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiException' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ApiException {
        throw new Error("The abstract class 'ApiException' cannot be instantiated.");
    }
}

export interface IApiException extends IException {
    statusCode?: HttpStatusCode;
}

export class ApiExceptionOfString extends ApiException implements IApiExceptionOfString {
    content?: string | null;

    constructor(data?: IApiExceptionOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
        }
    }

    static fromJS(data: any): ApiExceptionOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ApiExceptionOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ApiExceptionOfString {
        const json = this.toJSON();
        let result = new ApiExceptionOfString();
        result.init(json);
        return result;
    }
}

export interface IApiExceptionOfString extends IApiException {
    content?: string | null;
}

export enum HttpStatusCode {
    Continue = "continue",
    SwitchingProtocols = "switchingProtocols",
    Processing = "processing",
    EarlyHints = "earlyHints",
    OK = "ok",
    Created = "created",
    Accepted = "accepted",
    NonAuthoritativeInformation = "nonAuthoritativeInformation",
    NoContent = "noContent",
    ResetContent = "resetContent",
    PartialContent = "partialContent",
    MultiStatus = "multiStatus",
    AlreadyReported = "alreadyReported",
    IMUsed = "imUsed",
    MultipleChoices = "ambiguous",
    Ambiguous = "ambiguous",
    MovedPermanently = "moved",
    Moved = "moved",
    Found = "redirect",
    Redirect = "redirect",
    SeeOther = "redirectMethod",
    RedirectMethod = "redirectMethod",
    NotModified = "notModified",
    UseProxy = "useProxy",
    Unused = "unused",
    TemporaryRedirect = "temporaryRedirect",
    RedirectKeepVerb = "temporaryRedirect",
    PermanentRedirect = "permanentRedirect",
    BadRequest = "badRequest",
    Unauthorized = "unauthorized",
    PaymentRequired = "paymentRequired",
    Forbidden = "forbidden",
    NotFound = "notFound",
    MethodNotAllowed = "methodNotAllowed",
    NotAcceptable = "notAcceptable",
    ProxyAuthenticationRequired = "proxyAuthenticationRequired",
    RequestTimeout = "requestTimeout",
    Conflict = "conflict",
    Gone = "gone",
    LengthRequired = "lengthRequired",
    PreconditionFailed = "preconditionFailed",
    RequestEntityTooLarge = "requestEntityTooLarge",
    RequestUriTooLong = "requestUriTooLong",
    UnsupportedMediaType = "unsupportedMediaType",
    RequestedRangeNotSatisfiable = "requestedRangeNotSatisfiable",
    ExpectationFailed = "expectationFailed",
    MisdirectedRequest = "misdirectedRequest",
    UnprocessableEntity = "unprocessableEntity",
    Locked = "locked",
    FailedDependency = "failedDependency",
    UpgradeRequired = "upgradeRequired",
    PreconditionRequired = "preconditionRequired",
    TooManyRequests = "tooManyRequests",
    RequestHeaderFieldsTooLarge = "requestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "unavailableForLegalReasons",
    InternalServerError = "internalServerError",
    NotImplemented = "notImplemented",
    BadGateway = "badGateway",
    ServiceUnavailable = "serviceUnavailable",
    GatewayTimeout = "gatewayTimeout",
    HttpVersionNotSupported = "httpVersionNotSupported",
    VariantAlsoNegotiates = "variantAlsoNegotiates",
    InsufficientStorage = "insufficientStorage",
    LoopDetected = "loopDetected",
    NotExtended = "notExtended",
    NetworkAuthenticationRequired = "networkAuthenticationRequired",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}